import { FunctionComponent as F } from "react";
import { Box, TableRow, TableCell, Typography, Stack } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { timestampToSeconds } from "../../utils/string";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LinkOpt from '../UI/Icons/LinkOpt';
import { IValue } from "./RefsTable";
import TextTooltipOpt from "../UI/Tooltip/TextTooltipOpt";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";



interface IProps
{
  headings: { Header: string; accessor: string; }[];
  row: IValue;
  open: boolean;
  handleToggleOpen: (refId: number) => void;
  handleVote: (refId: number) => void;
}

const RefsTableRowHeader: F<IProps> = (props: IProps) =>
{
  const username = useSelector((state: IState) => state.user.username);

  const firstRef = props.row.spiels.map(s => s.refs).flat()[0];

  const addTimestamp = (url: string) =>
  {
    if(props.row.startTime)
    {
      const secondsStr = String(timestampToSeconds(props.row.startTime));
      if(url && url.includes("youtube.com/watch"))
        url += '&t=' + secondsStr + 's';
      else if(url && url.includes("youtu.be/"))
        url += '?t=' + secondsStr + 's';
    }

    return url;
  };


  return(
    <TableRow key={firstRef.refId}>
      {props.headings.map(heading => heading.accessor).map((accessor, i) =>
      {
        return (
          <TableCell key={i}>
            {(() =>
            {
              switch(accessor)
              {
              case 'url':
                return(
                  <LinkOpt
                    url={props.row.url}
                    tooltipText={addTimestamp(props.row[accessor])}
                    iconHeight='200px' />);
              case 'votes':
                return(
                  <TextTooltipOpt showtooltip={!username} lines={["Please log in to vote"]}>
                    <Stack direction='row'>
                      <ArrowDropUpIcon
                        fontSize='large'
                        sx={{ mt: -0.8, color: props.row.voted ? 'green' : 'gray' }}
                        onClick={() => username && props.handleVote(firstRef.refId)}/>
                      <Typography fontWeight={props.row.voted ? 'bold' : 'regular'} fontSize={14}>
                        {props.row.votes}
                      </Typography>
                    </Stack>
                  </TextTooltipOpt>);
              case 'title':
                return props.row.title;
              case 'platform':
                return props.row.platform || (props.row.bookFormat + " book");
              case 'date':
                return(<Box style={{ width: '75px' }}>{
                  String(props.row[accessor].getFullYear()) + "-" +
                  (props.row[accessor].getMonth() + 1) + "-" +
                  props.row[accessor].getDate()}</Box>);
              case 'nRefsInPost':
                return props.row.nRefsInPost;
              case 'startTime':
                return props.row.startTime;
              }
            })()}
          </TableCell>);
      })}
      <TableCell key={props.headings.length}>
        {(props.open ?
          <KeyboardArrowDownIcon
            onClick={() => props.handleToggleOpen(firstRef.refId)}/> :
          <KeyboardArrowUpIcon
            onClick={() => props.handleToggleOpen(firstRef.refId)}/>)}
      </TableCell>

    </TableRow>);
};

export default RefsTableRowHeader;
